import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
import MenuComponent from "components/MenuComponent/MenuComponent";
import EmailModel from "components/EmailModel/EmailModel";
import AvatarComponent from "components/Avatar/AvatarComponent";
import ModalComponent from "components/ModalComponent/ModalComponent";
import EditUserForm from "components/Forms/EditUserForm";
// import getUserType from "utils/UserTypeUtils";

function UsersTable({
  users,
  openAlertModel,
  HandleUserLock,
  HandleUserActivate,
  HandleUserDelete,
  HandleUserPasswordReset,
  HandleUserEdit,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEmailModel, setOpenEmailModel] = useState(false);
  const [userMenueModell, setuserMenueModel] = useState("");
  const [editUserModal, setEditUserModal] = useState(false);
  const [editUserTarget, setEditUserTarget] = useState(null);
  const handleUserMenu = (e, userp) => {
    setAnchorEl(e.currentTarget);
    setOpenMenu(true);
    setuserMenueModel(userp);
  };
  const closeMenu = () => {
    setOpenMenu(false);
  };

  const lockUser = (id, val) => {
    HandleUserLock(id, val);
    closeMenu();
  };
  const activateUser = (id, val) => {
    HandleUserActivate(id, val);
    closeMenu();
  };
  const deleteUser = (id) => {
    HandleUserDelete(id);
    closeMenu();
  };
  const resetPassword = (id) => {
    HandleUserPasswordReset(id);
    closeMenu();
  };

  const openEditUser = (userp) => {
    setEditUserTarget(userp);
    setEditUserModal(true);
  };

  const handleEditSubmit = (data) => {
    HandleUserEdit(data);
    setEditUserModal(false);
    setEditUserTarget(null);
  };

  // users.forEach((element) => {
  //   console.log(element);
  // });

  return (
    <div className="b-organization-listing">
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead className="b-organization-listing__head">
            <TableRow>
              <TableCell className=" b-organization-listing__cell" />
              <TableCell
                className="remove font-bold b-organization-listing__cell"
                align="left"
              >
                <span className="remove font-bold b-organization-listing__name">
                  Name
                </span>
              </TableCell>
              <TableCell
                className="remove font-bold b-organization-listing__cell"
                align="left"
              >
                <span className="remove font-bold b-organization-listing__name">
                  User Type
                </span>
              </TableCell>
              <TableCell
                className="remove font-bold b-organization-listing__cell"
                align="left"
              >
                <span className=" remove font-bold b-organization-listing__name">
                  Primary Email
                </span>
              </TableCell>
              <TableCell
                className="font-bold b-organization-listing__cell"
                align="left"
              />
            </TableRow>
          </TableHead>
          <TableBody className="index-organization-table">
            <>
              {users.map((userp) => {
                return (
                  <React.Fragment key={userp.id}>
                    <TableRow key={userp.id}>
                      <TableCell>
                        <AvatarComponent
                          firstname={userp?.user.first_name}
                          lastname={userp?.user.last_name}
                          userType={userp?.user.type}
                          avatar={userp?.profile_pic}
                          locked={userp?.is_locked}
                        />
                      </TableCell>
                      <TableCell>
                        <span className="b-organization-listing__org-title">
                          {userp.user.first_name}
                        </span>
                        &nbsp;
                        <span className="b-organization-listing__org-title">
                          {userp.user.last_name}
                        </span>
                      </TableCell>
                      {/* <TableCell className="remove dafault-font-family">
                        <span className="b-organization-listing__org-email">
                          {getUserType(userp.user.type)}
                        </span>
                      </TableCell> */}
                      <TableCell className="remove dafault-font-family">
                        <span className="b-organization-listing__org-email">
                          {userp.roles && userp.roles.length > 0
                            ? userp.roles
                                .map(
                                  (role) =>
                                    role.text.charAt(0).toUpperCase() +
                                    role.text.slice(1).toLowerCase()
                                )
                                .join(", ")
                            : "No Role"}
                        </span>
                      </TableCell>
                      <TableCell className="remove dafault-font-family">
                        <div className="b-organization-listing__org-email">
                          {userp.user.email}
                        </div>
                      </TableCell>
                      <TableCell>
                        {/* <IconButton>
                          <MoreVertIcon
                            className="b-organization-listing__textcolor"
                            id={userp.user.id}
                            onClick={(e) => handleUserMenu(e, userp)}
                          />
                        </IconButton> */}
                        <IconButton onClick={(e) => handleUserMenu(e, userp)}>
                          <MoreVertIcon
                            className="b-organization-listing__textcolor"
                            id={userp.user.id}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </>
            {openMenu && (
              <MenuComponent
                menuAnchorEl={anchorEl}
                openAnchor={openMenu}
                handleCloseMenu={closeMenu}
                userId={userMenueModell.user.id}
                isLocked={userMenueModell.is_locked}
                isActive={userMenueModell.user.is_active}
                handleLockUser={lockUser}
                handleActivateUser={activateUser}
                handleDeleteUser={deleteUser}
                handleResetPasswordUser={resetPassword}
                openEmailModel={() => setOpenEmailModel(true)}
                openAlertModel={openAlertModel}
                userp={userMenueModell}
                handleEditUser={openEditUser}
              />
            )}

            {openEmailModel && (
              <EmailModel
                openEmailModel={openEmailModel}
                closeEmailModel={() => setOpenEmailModel(false)}
                userId={userMenueModell.user.id}
                openAlertModel={openAlertModel}
                userp={userMenueModell}
              />
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {editUserModal && editUserTarget && (
        <ModalComponent
          isLocked={false}
          title="Edit User"
          openModal={editUserModal}
          handleCloseModal={() => {
            setEditUserModal(false);
            setEditUserTarget(null);
          }}
          ModalBody={
            <EditUserForm
              userp={editUserTarget}
              handleResponse={handleEditSubmit}
            />
          }
        />
      )}
    </div>
  );
}
// UsersTable.propTypes = {
//   users: PropTypes.oneOfType([PropTypes.object]).isRequired,
//   openAlertModel: PropTypes.func.isRequired,
//   HandleUserLock: PropTypes.func.isRequired,
//   HandleUserActivate: PropTypes.func.isRequired,
//   HandleUserDelete: PropTypes.func.isRequired,
//   HandleUserPasswordReset: PropTypes.func.isRequired,
// };
UsersTable.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number]).isRequired,
      user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number]).isRequired,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        email: PropTypes.string,
        type: PropTypes.string,
        is_active: PropTypes.bool,
      }).isRequired,
      profile_pic: PropTypes.string,
      is_locked: PropTypes.bool,
    })
  ).isRequired,
  openAlertModel: PropTypes.func.isRequired,
  HandleUserLock: PropTypes.func.isRequired,
  HandleUserActivate: PropTypes.func.isRequired,
  HandleUserDelete: PropTypes.func.isRequired,
  HandleUserPasswordReset: PropTypes.func.isRequired,
  HandleUserEdit: PropTypes.func.isRequired,
};

export default UsersTable;
